// extracted by mini-css-extract-plugin
export default {"modalWrapper":"modalWrapper__app__dc6HY"};